module.exports = __webpack_public_path__ + "static/media/loading-psd.c16a67f6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading-psd.gif
// module id = 664
// module chunks = 0